import { isValidCnpjInput } from '@solfacil/frontend-utils/cnpj';
import { z } from 'zod';

const inactiveAccountsFiltersSchema = z.object({
  competency_month: z.string().min(1, 'Mês de competência é obrigatório'),
  partner_cnpj: z.string()
    .optional()
    .refine((val) => !val?.trim() || isValidCnpjInput(val), { message: 'CNPJ inválido' }),
  partner_id: z.string().optional(),
  processing_status: z.enum(['PENDING_APPROVAL', 'APPROVED', 'REJECTED', 'COMMUNICATION_SENT', 'FINISHED']),
  status_solfacil: z.enum(['REGULAR', 'BLOCKED', '']).optional(),
});

export default inactiveAccountsFiltersSchema;
